import React, { useState, useEffect } from 'react';
import {
  Box, Button, CardHeader, TableBody, Divider,
  MenuItem, Grid, InputLabel, TextField, Table, TableCell, TableHead, TableRow
} from '@material-ui/core';
import services from '../../Services';
import { Formik } from 'formik';
import * as Yup from "yup";
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

export default function FuelConsume({ factoryData, arrayFuel, setArrayFuel, StatusID }) {
  const alert = useAlert();
  const [fuelTypes, setFuelTypes] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [manufacturingDetail, setManufacturingDetail] = useState({
    fuelTypeID: 0,
    jobTypeID: 0,
    amount: 0,
    fuelMeasuringUnitID: 0
  });
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  useEffect(() => {
    trackPromise(
      getJobTypesForDropdown(),
    );
  }, []);

  useEffect(() => {
    trackPromise(getFuelTypesForDropdown());
  }, [factoryData])


  async function getFuelTypesForDropdown() {
    const fuelTypes = await services.getFuelTypesForDropdown(factoryData);
    setFuelTypes(fuelTypes);
  }

  async function getJobTypesForDropdown() {
    const jobTypes = await services.getJobTypesForDropdown();
    setJobTypes(jobTypes);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function generateFuelTypeDropDownMenu(fuelTypes) {
    let items = []
    if (fuelTypes != null) {
      for (const [key, value] of Object.entries(fuelTypes)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;

    let updatedDetail = {
      ...manufacturingDetail,
      [e.target.name]: value
    };

    if (e.target.name === 'fuelTypeID' && value !== '0') {
      const selectedFuelType = fuelTypes[value];
      if (selectedFuelType && selectedFuelType.unit) {
        updatedDetail.fuelMeasuringUnitID = value;
      }
    } else if (e.target.name === 'fuelTypeID' && value === '0') {
      updatedDetail.fuelMeasuringUnitID = 0;
    }

    setManufacturingDetail(updatedDetail);
  }

  async function handleClickDelete(rowData, index) {
    setDeleteIndex(index);
    setDeleteConfirmationOpen(true);
  }

  async function InactiveFieldDetails() {
    setDeleteConfirmationOpen(false);
    const dataDelete = [...arrayFuel];
    dataDelete.splice(deleteIndex, 1);
    setArrayFuel([...dataDelete]);
    setDeleteIndex(null);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
    setDeleteIndex(null);
  };

  function AddFieldData() {
    const selectedFuelType = fuelTypes[manufacturingDetail.fuelTypeID];

    const newModel = {
      fuelTypeID: parseInt(manufacturingDetail.fuelTypeID),
      fuelTypeName: selectedFuelType ? selectedFuelType.name : '',
      jobTypeID: parseInt(manufacturingDetail.jobTypeID),
      jobTypeName: jobTypes[manufacturingDetail.jobTypeID],
      amount: parseFloat(manufacturingDetail.amount),
      fuelMeasuringUnitID: parseInt(manufacturingDetail.fuelMeasuringUnitID),
      fuelMeasuringUnitName: selectedFuelType ? selectedFuelType.unit : ''
    };

    const isDuplicate = arrayFuel.some(
      (row) =>
        row.fuelTypeID === newModel.fuelTypeID &&
        row.jobTypeID === newModel.jobTypeID
    );

    if (isDuplicate) {
      alert.error('Cannot Add Duplicate Fuel Consumption');
      return;
    }
    else {
      setArrayFuel([...arrayFuel, newModel]);
      alert.success('Row Updated');
    }
    setManufacturingDetail((prevState) => ({
      ...prevState,
      fuelTypeID: 0,
      jobTypeID: 0,
      amount: '',
      fuelMeasuringUnitID: 0
    }));
  }

  return (
    <>
      <Formik
        initialValues={{
          fuelTypeID: manufacturingDetail.fuelTypeID,
          jobTypeID: manufacturingDetail.jobTypeID,
          amount: manufacturingDetail.amount,
          fuelMeasuringUnitID: manufacturingDetail.fuelMeasuringUnitID
        }}
        validationSchema={
          Yup.object().shape({
            fuelTypeID: Yup.number().required('Fuel Type is required').min("1", 'Please Select a Fuel Type'),
            jobTypeID: Yup.number().required('Job Type is required').min("1", 'Please Select a Job Type'),
            amount: Yup.number().required('Quantity is required').min("1", 'Quantity should be grater than 0'),
            fuelMeasuringUnitID: Yup.number().required('Measuring Unit is required').min("1", 'Please Select a Measuring Unit'),
          })
        }
        enableReinitialize
        onSubmit={(event) => AddFieldData(event)}
      >
        {({
          errors,
          handleBlur,
          handleSubmit,
          touched,
          isSubmitting
        }) => (
          <form onSubmit={handleSubmit}>
            <>
              <CardHeader title={"Fuel Consumption"} />
              <Divider />
              &nbsp;
              <Grid container spacing={3}>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="fuelTypeID">
                    Fuel Type *
                  </InputLabel>
                  <TextField select
                    fullWidth
                    error={Boolean(touched.fuelTypeID && errors.fuelTypeID)}
                    helperText={touched.fuelTypeID && errors.fuelTypeID}
                    name="fuelTypeID"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    size='small'
                    value={manufacturingDetail.fuelTypeID}
                    variant="outlined"
                    id="fuelTypeID"
                    disabled={StatusID == 2 || StatusID == 3}
                  >
                    <MenuItem value="0">--Select Fuel Type--</MenuItem>
                    {generateFuelTypeDropDownMenu(fuelTypes)}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="jobTypeID">
                    Job Type *
                  </InputLabel>
                  <TextField select
                    fullWidth
                    error={Boolean(touched.jobTypeID && errors.jobTypeID)}
                    helperText={touched.jobTypeID && errors.jobTypeID}
                    name="jobTypeID"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    size='small'
                    value={manufacturingDetail.jobTypeID}
                    variant="outlined"
                    id="jobTypeID"
                    disabled={StatusID == 2 || StatusID == 3}
                  >
                    <MenuItem value="0">--Select Job Type--</MenuItem>
                    {generateDropDownMenu(jobTypes)}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="amount">
                    Quantity *
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.amount && errors.amount)}
                    fullWidth
                    helperText={touched.amount && errors.amount}
                    name="amount"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    size='small'
                    value={manufacturingDetail.amount}
                    variant="outlined"
                    id="amount"
                    disabled={StatusID == 2 || StatusID == 3}
                    InputProps={{
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  >
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="fuelMeasuringUnitID">
                    Measuring Unit *
                  </InputLabel>
                  <TextField select
                    fullWidth
                    error={Boolean(touched.fuelMeasuringUnitID && errors.fuelMeasuringUnitID)}
                    helperText={touched.fuelMeasuringUnitID && errors.fuelMeasuringUnitID}
                    name="fuelMeasuringUnitID"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={manufacturingDetail.fuelMeasuringUnitID}
                    variant="outlined"
                    id="fuelMeasuringUnitID"
                    size='small'
                    inputProps={{ readOnly: true }}
                    disabled={StatusID == 2 || StatusID == 3}
                  >
                    <MenuItem value="0">--Select Measuring Unit--</MenuItem>
                    {manufacturingDetail.fuelTypeID !== 0 && fuelTypes[manufacturingDetail.fuelTypeID] && (
                      <MenuItem value={manufacturingDetail.fuelMeasuringUnitID}>
                        {fuelTypes[manufacturingDetail.fuelTypeID].unit}
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>
              </Grid>
              &nbsp;
              {StatusID == 0 || StatusID == 1 ?
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    color="primary"
                    variant="contained"
                    type='submit'
                    size='small'
                  >
                    Add
                  </Button>
                </Box> : null}
              {(arrayFuel.length > 0) ?
                <Table size='small' aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell align='center'>Fuel Type</TableCell>
                      <TableCell align='center'>Job Type</TableCell>
                      <TableCell align='center'>Quantity</TableCell>
                      <TableCell align='center'>Measuring Unit</TableCell>
                      {StatusID == 0 || StatusID == 1 ?
                        <TableCell align='center'>Actions</TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {arrayFuel.map((rowData, index) => (
                      <TableRow key={index}>
                        <TableCell align='center' component="th" scope="row" style={{ borderBottom: "none" }}>
                          {rowData.fuelTypeName}
                        </TableCell>
                        <TableCell align='center' component="th" scope="row" style={{ borderBottom: "none" }}>
                          {rowData.jobTypeName}
                        </TableCell>
                        <TableCell align='center' component="th" scope="row" style={{ borderBottom: "none" }}>
                          {parseFloat(rowData.amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </TableCell>
                        <TableCell align='center' component="th" scope="row" style={{ borderBottom: "none" }}>
                          {rowData.fuelMeasuringUnitName}
                        </TableCell>
                        <TableCell align='center' scope="row" style={{ borderBottom: "none" }}>
                          {StatusID == 0 || StatusID == 1 ?
                            <DeleteIcon
                              style={{
                                color: "red",
                                cursor: "pointer"
                              }}
                              size="small"
                              onClick={() => handleClickDelete(rowData, index)}
                            >
                            </DeleteIcon> : null}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table> : null}
              <Dialog open={deleteConfirmationOpen} onClose={handleCancelDelete}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                  <p>Are you sure, you want to delete this record?</p>
                </DialogContent>
                <DialogActions>
                  <Button onClick={InactiveFieldDetails} color="primary">
                    Delete
                  </Button>
                  <Button
                    onClick={handleCancelDelete} color="primary">
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            </>
            &nbsp;
          </form >
        )
        }
      </Formik >
    </>
  )
}
